import {TaxState} from '../reducers/tax';

export const selectTax = (state): TaxState => state.get('tax').toJS();

export const selectTaxSubmitted = (state): boolean => state.getIn(['tax', 'submitted']);

export const selectTaxConsent = (state): boolean => state.getIn(['tax', 'isConsent']);

export const selectTaxLoading = (state): boolean => state.getIn(['tax', 'loading']);
